/**
 * The console's queue of donor notes waiting to go on the event screen (GH-887, DEC-053 decided by
 * the owner 2026-10-04).
 *
 * A donor ticks "Show on the event screen" beside their note; the note then waits here until a host
 * approves or declines it. Approval is what puts it on the public feed — and so on the big screen's
 * gift announcement and its "Just now" list. A decline after an approval takes it back down.
 *
 * Staff-only (`engagement.manage`, the comment wall's permission): the queue carries the donor's
 * name as the organization sees it, with the "Anonymous publicly" flag (DEC-049), and never a
 * contact detail. A donor anonymous to all organizations is never in it.
 */
import { z } from "zod";
import { moneySchema } from "./v1.js";
export const SCREEN_NOTE_STATUSES = ["pending", "approved", "declined"];
export const screenNoteSchema = z.object({
    donationId: z.string().uuid(),
    amount: moneySchema,
    /** The donor's words, as stored. Shown as plain text (`dir="auto"`). */
    note: z.string(),
    /** The donor's name for the organization; null when they gave none. */
    donorName: z.string().nullable(),
    /** The gift is anonymous to the public: the screen shows the note with no name. */
    publiclyAnonymous: z.boolean(),
    givenAt: z.string(),
    status: z.enum(SCREEN_NOTE_STATUSES),
    decidedAt: z.string().nullable(),
});
export const screenNoteQueueResponseSchema = z.object({
    notes: z.array(screenNoteSchema),
});
export const screenNoteDecisionRequestSchema = z
    .object({ decision: z.enum(["approved", "declined"]) })
    .strict();
//# sourceMappingURL=screen-notes.js.map